import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { cn } from '@/lib/utils'
import React from 'react'

type BreadcrumbItemType = {
  label: string
  href?: string
  isCurrentPage?: boolean
  isCategory?: boolean
}

type Props = {
  variant?: 'default' | 'wide'
  items: BreadcrumbItemType[]
}

export default function LayoutBreadcrumb({
  variant = 'default',
  items,
}: Props) {
  return (
    <div className="hidden sm:block px-4">
      <div
        className={cn(
          'flex flex-col md:flex-row gap-8 pt-4 pb-4 text-tertiary mx-auto',
          {
            'max-w-7xl': variant === 'default',
            'max-w-full': variant === 'wide',
          }
        )}
      >
        <Breadcrumb>
          <BreadcrumbList>
            {items.map((item, index) => (
              <React.Fragment key={index}>
                <BreadcrumbItem>
                  {item.href ? (
                    <BreadcrumbLink href={item.href}>
                      {item.label}
                    </BreadcrumbLink>
                  ) : (
                    <BreadcrumbPage>{item.label}</BreadcrumbPage>
                  )}
                </BreadcrumbItem>
                {index < items.length - 1 && (
                  <BreadcrumbSeparator>
                    {item.isCategory && items[index + 1]?.isCategory ? (
                      <span>/</span>
                    ) : null}
                  </BreadcrumbSeparator>
                )}
              </React.Fragment>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </div>
  )
}
